import React from 'react'
import { MultiComboboxProps, MultiCombobox, OptionKey } from 'view/components/options'
import { Field } from 'view/components/inputs'
import { RepoTypeHelper } from 'model'
import { RepoType } from 'api'

export type RepoTypeMultiComboboxOmitProps = Omit<MultiComboboxProps<RepoType, string>, 'optionKeys'>

export interface RepoTypeMultiComboboxProps extends RepoTypeMultiComboboxOmitProps {
  optionKeys: OptionKey[]
}

export const RepoTypeMultiCombobox = React.forwardRef((props: RepoTypeMultiComboboxProps, ref: React.Ref<MultiCombobox>) => {
  return <MultiCombobox ref={ref} getOptionText={RepoTypeHelper.getName} {...props} />
})

export const RepoTypeMultiComboboxField = Field(RepoTypeMultiCombobox)
